// Redux
import { Reducer } from 'redux';
import { produce, Draft } from 'immer';

// Models
import { CasesActionTypes, CasesState } from 'app/modules/casesOld/models';

// Actions
import CasesActions from 'app/modules/casesOld/actions';

// Utils
import deepFreeze from 'app/shared/utils/deepFreeze';
import { INITIAL_CASE } from 'app/modules/cases/constants';

const initialState: Readonly<CasesState> = {
  case: INITIAL_CASE,
};

// to ensure initialState is readonly
deepFreeze(initialState);

const reducer: Reducer<CasesState> = (
  state = initialState,
  action: CasesActions,
) => {
  return produce(state, (draft: Draft<CasesState>) => {
    switch (action.type) {
      case CasesActionTypes.UPLOAD_FILES_SUCCESS:
        draft.case.attachments = action.payload.attachments;
        return;

      case CasesActionTypes.RETRIEVE_CASE_SUCCESS:
        draft.case = action.payload;
        return;

      case CasesActionTypes.EDIT_CASE_SUCCESS: {
        // only change left hand side of cases list when page is changed
        draft.case = { ...draft.case, ...action.payload };
        return;
      }

      case CasesActionTypes.DELETE_DOCUMENT_SUCCESS:
      case CasesActionTypes.ADD_DOCUMENTS_SUCCESS:
        draft.case.attachments = action.payload.attachments;
        return;
    }
  });
};

export { reducer as casesReducer };
